import { IconProps } from '../icon-props-interface';
import '../icons.scss';


export const IconNext = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.85512 6.45372L1.73896 0.223657C1.5975 0.0794465 1.40867 0 1.20732 0C1.00597 0 0.817133 0.0794465 0.675674 0.223657L0.225262 0.682352C-0.0678243 0.981244 -0.0678243 1.46703 0.225262 1.76547L5.36114 6.9971L0.219563 12.2345C0.0781042 12.3787 5.53861e-09 12.571 5.62892e-09 12.776C5.71934e-09 12.9812 0.0781042 13.1734 0.219563 13.3178L0.669975 13.7763C0.811546 13.9206 1.00027 14 1.20162 14C1.40297 14 1.59181 13.9206 1.73327 13.7763L7.85512 7.54059C7.99691 7.39592 8.07479 7.20277 8.07434 6.99744C8.07479 6.79131 7.99691 6.59827 7.85512 6.45372Z" fill={color}/>
        </svg>
    </div>
);

export default IconNext;
